import { Link, Typography } from 'omakase';
import { useFeatureFlagForConsumer } from 'featureFlags/useConsumerFeatureFlag';
import React from 'react';
import ResyLogo from 'components/header/ResyLogo';
import cssDefs from 'components/header/resyNetworkBannerCssDefs';

const RESY_LEARN_MORE_URL =
  'https://blog.resy.com/newsroom/resy-welcomes-tock-restaurants-wineries-experiences';

const ResyNetworkBanner: React.FC = () => {
  const isEnabled = useFeatureFlagForConsumer('CONSUMER_RESY_COBRAND');

  if (!isEnabled) {
    return null;
  }

  return (
    <div css={cssDefs.banner} data-testid="resy-network-banner">
      <ResyLogo css={cssDefs.logo} aria-hidden />
      <Typography variant="body02" color="fgContrast">
        Tock is now part of the Resy network.{' '}
        <Link
          underline="always"
          href={RESY_LEARN_MORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          css={cssDefs.link}
        >
          Learn more ↗
        </Link>
      </Typography>
    </div>
  );
};

export default ResyNetworkBanner;
